import { Box, Radio } from '@mui/material';

import RadioButtonCheckedIcon from '../svgs/RadioButtonCheckedIcon';
import RadioButtonUncheckedIcon from '../svgs/RadioButtonUncheckedIcon';
import { Themes } from '../../constants';

import type { RadioProps } from '@mui/material';

interface FHRadioProps extends RadioProps {
  colorTheme?: Themes;
  showDisabled?: boolean;
}

function FHRadio(props: FHRadioProps) {
  const { colorTheme = Themes.Primary, showDisabled = false, ...rest } = props;

  return (
    <Radio
      {...rest}
      disableRipple
      checkedIcon={<RadioButtonCheckedIcon theme={colorTheme} />}
      icon={
        rest.disabled && !showDisabled ? (
          <Box sx={{ width: '20px' }}></Box>
        ) : (
          <RadioButtonUncheckedIcon theme={colorTheme} />
        )
      }
    />
  );
}

export default FHRadio;
